module.exports = {
    owlCarousel: [ '$parse', '$timeout', function($parse, $timeout){
        return {
            restrict: 'E',
            scope: true,
            require: [ 'owlCarousel' ],
            controller: [ '$scope', '$element', function($scope, $elem) {
                var carousel = $elem.find('.owl-carousel');
                var model = null;
                
                this.page = $scope.page = {
                    index: 0,
                    count: 0,
                    size: 0
                };

                this.item = $scope.item = {
                    count: 0,
                    index: 0
                };

                this.pagination = $scope.pagination = {
                    current: 0,
                    total: 0
                };

                this.next = function(data) {
                    carousel.trigger('next.owl.carousel', data);
                };

                this.prev = function(data) {
                    carousel.trigger('prev.owl.carousel', data);
                };

                this.goto = function(offset, transitionTime) {
                    carousel.trigger('to.owl.carousel', [ offset, transitionTime ]);
                };

                /**
                 * Va aller a l'item
                 */
                this.selectItem = function(item, transitionTime) {
                    var elements = carousel.find('[owl-carousel-item]');
                    if (!elements.length) {
                        return;
                    }

                    for (var i = 0, sz = elements.length; i < sz; i++) {
                        var ctrl = angular.element(elements.get(i)).controller('owlCarouselItem');
                    
                        if (ctrl && ctrl.getData() === item) {
                            console.debug('TRIGGER SLEECT ITEM => ', i );
                            carousel.trigger('to.owl.carousel', [ i, (!transitionTime ? 0 : transitionTime) ]);
                            return true;
                        }
                    }
                };

                this.setModel = function(oModel) {
                    model = oModel;
                    return this;
                };

                this.getModelValue = function() {
                    if (model) {
                        return model($scope);
                    }
                    return undefined;
                };

                var shadow = this.getModelValue();
                this.setSelectedItem = function(data) {
                    $scope.$emit('owlCarousel.selectedItemChanged', data);
                    shadow = data;

                    if (model) {
                        $scope.$parent.$evalAsync(function(){
                            model.assign($scope.$parent, data);
                        });
                    }
                };

                //garde une copie locale de la data
                this.getModelShadow = function() {
                    return shadow;
                };
            } ],
            link: function($scope, $elem, $attr, $ctrl){
                var carousel = $elem.find('.owl-carousel');
                var owlController = $ctrl[0];
                var model = ($attr.model ? $parse($attr.model) : null);

                var sharedController = null;
                if ($attr.controllerAs) {
                    sharedController = $parse($attr.controllerAs);
                    $scope.$parent.$evalAsync(function(){
                        sharedController.assign($scope.$parent, owlController);
                    });
                }

                owlController.setModel(model);

                $scope.$watch($attr.model, function(newVal, oldVal) {
                    console.debug('modelValue changed', $attr.controllerAs, JSON.stringify(newVal), JSON.stringify(oldVal));
                    if (newVal === oldVal || newVal === owlController.getModelShadow()) {
                        return;
                    }

                    owlController.selectItem(newVal, 0);
                });
                console.debug('SET MODEL FU => ', JSON.stringify(owlController.getModelValue()));

                function updatePagination(event) {
                    $scope.$evalAsync(function(){
                        angular.extend($scope.item, event.item);
                        angular.extend($scope.page, event.page);

                        $scope.pagination.total = $scope.item.count - $scope.page.size + 1;
                        $scope.pagination.current = $scope.item.index + 1;
                    });
                }

                function onCarouselChanged(event) {
                    updatePagination(event);

                    var childController = angular.element(carousel.find('[owl-carousel-item]').get(event.item.index)).controller('owlCarouselItem');
                    
                    console.debug(
                        'CHILD CTRL => ',
                        event,
                        childController, 
                        carousel.find('.owl-stage >*'), 
                        carousel.find('.owl-stage >*').get(event.item.index), 
                        event.item.index
                    );

                    owlController.setSelectedItem(
                        (childController ? childController.getData() : null)
                    );
                }

                function onCarouselInitialized(event) {
                    updatePagination(event);
                    
                    var model = owlController.getModelValue();
                    if (model) {
                        $timeout(function(){
                            owlController.selectItem(model, 0); 
                        }, 1);
                    }

                    carousel.on('changed.owl.carousel', onCarouselChanged);              
                };


                function initCarousel() {
                    carousel.on('initialized.owl.carousel', onCarouselInitialized);
                    carousel.owlCarousel($parse($attr.options)($scope));
                }

                function destroyCarousel() {
                    carousel.off('initialized.owl.carousel');
                    carousel.off('changed.owl.carousel');
                    carousel.trigger('destroy.owl.carousel');
                    carousel.find('.owl-stage').remove();        
                };

                if ($attr.watch) {
                    $scope.$watch($attr.watch, function(newVal, oldVal) {
                        destroyCarousel();
                        initCarousel();
                    });
                }

                $scope.$on('$destroy', function() {
                    destroyCarousel();
                    sharedController.assign($scope.$parent, null);
                });

                initCarousel();
            }
        }
    } ],
    owlCarouselNext: [ '$parse', function($parse){
        return { 
            restrict: 'EA',
            require: '^owlCarousel',
            link: function($scope, $elem, $attr, $ctrl) {
                $elem.on('click', function() {
                    $ctrl.next($parse($attr.owlCarouselNext)($scope));
                });
            }
        };
    } ],
    owlCarouselPrev: [ '$parse', function($parse) {
        return {
            restrict: 'EA',
            require: '^owlCarousel',
            link: function($scope, $elem, $attr, $ctrl) {
                $elem.on('click', function() {
                    $ctrl.prev($parse($attr.owlCarouselPrev)($scope));
                });
            }
        }
    } ],
    owlCarouselItem: [ function() {
        return {
            restrict: 'A',
            require: [ 'owlCarouselItem', '^owlCarousel' ],
            scope: {
                data: '=?owlCarouselItem'
            },
            controller: [ '$scope', function($scope) {
                this.getData = function(){
                    return $scope.data;
                }
            }]
        };
    } ],
};


//////////////////
// WEBPACK FOOTER
// ./assets/app/owlCarousel.directive.js
// module id = 1
// module chunks = 0